import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import Route from './Route';
import Circuit from './Circuit';
import FuelStation from './FuelStation';
import ItineraryGroup from './ItineraryGroup';
import Segment from './Segment';
import Toll from './Toll';
import TollExtraordinaryAssignment from './TollExtraordinaryAssignment';
import RouteData from './RouteData';
import TollLiquidation from './TollLiquidation';

export default combineReducers({
  UnitHome,
  Route,
  Circuit,
  FuelStation,
  ItineraryGroup,
  Segment,
  Toll,
  TollExtraordinaryAssignment,
  RouteData,
  TollLiquidation,
});
